import { userState } from "../../interface/MainInterface";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

interface propsType {
  userState: userState;
}
const reservationCategories = [
  {
    icon: "/images/icon-gym.png",
    label: "헬스장",
    operatingHours: "운영시간 : 05시 ~ 23시",
    path: "/reservationhealth",
  },
  {
    icon: "/images/icon-player.png",
    label: "골프 연습장",
    operatingHours: "운영시간 : 05시 ~ 23시",
    path: "/reservationgolf",
  },
  {
    icon: "/images/icon-studying.png",
    label: "독서실",
    operatingHours: "운영시간 : 06시 ~ 익일 02시",
    path: "/reservationstudy",
  },
  {
    icon: "/images/icon-lockers.png",
    label: "락커 신청",
    operatingHours: "운영시간 : 시설물 이용시간",
    path: "/reservationlocker",
  },
];

const Reservation = (_props: propsType) => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="hpoint-renewal hp-reservation-page hp-reservation-hub">
      <section className="hp-reservation-guide hp-reservation-guide--primary" aria-labelledby="reservation-period-title">
        <span className="hp-reservation-guide__eyebrow">MONTHLY RESERVATION</span>
        <h2 id="reservation-period-title" className="hp-reservation-guide__title">
          다음 달 커뮤니티 신청
        </h2>
        <p className="hp-reservation-guide__description">앱에서 원하는 커뮤니티 시설을 편리하게 신청할 수 있어요.</p>
        <div className="hp-reservation-guide__period">
          <div className="hp-reservation-guide__period-row">
            <span>앱 신청 기간</span>
            <strong>25일 ~ 말일</strong>
            <small>다음달 시설 신청 가능</small>
          </div>
          <div className="hp-reservation-guide__period-row">
            <span>관리사무소 신청</span>
            <strong>1일 ~ 24일</strong>
            <small>관리사무소를 통해서 신청 가능</small>
          </div>
        </div>
      </section>

      <section className="hp-category-grid" aria-label="예약 시설">
        {reservationCategories.map((category) => (
          <button
            key={category.path}
            className="hp-category-card"
            type="button"
            onClick={() => navigate(category.path)}
          >
            <img className="hp-category-card__icon" src={category.icon} alt="" />
            <span className="hp-category-card__label">{category.label}</span>
            <span className="hp-category-card__hours">{category.operatingHours}</span>
          </button>
        ))}
      </section>
    </main>
  );
};

export default Reservation;
